var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn",attrs:{"type":"button"},on:{"click":_vm.repeatProject}},[_vm._v(" Repeat project ")])}
var staticRenderFns = []

export { render, staticRenderFns }